module.exports = "<div id=\"mapCanvas\" class=\" map_lhs_2 pad0\" style=\"overflow:hidden; height: 600px;\">\r\n    <ng2-map [options]=\"mapOptions\">\r\n        <marker *ngFor=\"let pos of positions\" [position]=\"pos\"></marker>\r\n\r\n    </ng2-map>\r\n\r\n    {{positions}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/map-component/map.component.html
// module id = ./src/app/sharedcomponents/map-component/map.component.html
// module chunks = main